export default class DefaultHandler {
  constructor(fieldType, overrides) {
    this.fieldType = fieldType;
    this.overrides = overrides;
  }

  // fieldType Picklist in our case
  canHandle(property) {
    return property.type === this.fieldType;
  }

  handleField(property, defaultType) {
    const { id, name, label } = property;

    let formField = {
      id,
      name: label,
      type: defaultType,
    };

    if (this.overrides.length) {
      const fieldOverride = this.overrides.find(({ id }) => id === name);
      if (fieldOverride) {
        formField = {
          ...formField,
          ...fieldOverride,
        };
      }
    }
    return formField;
  }
}
